import { useState, useEffect } from 'react';
import chevron from "./chevron-down.svg";
import plus from './plus.svg';
import minus from './minus.svg';
import online from './online-icon.svg';
import printAndOnline from './print-and-online-icon.svg';
import radio from './radio-icon.svg';
import tv from './tv-icon.svg';

const independentIcon = <span className='indy-pill'>Independent</span>;
const corporateIcon = <span className='corp-pill'>Corporate</span>

const mediumIcons = {
    "Online": <img src={online} alt="online-icon" className='filter-option-icon' />,
    "Print and Online": <img src={printAndOnline} alt="print-and-online-icon" className='filter-option-icon' />,
    "Print": <img src={printAndOnline} alt="print-icon" className='filter-option-icon' />,
    "Community Radio": <img src={radio} alt="radio-icon" className='filter-option-icon' />,
    "Local TV Station": <img src={tv} alt="tv-icon" className='filter-option-icon' />
}

const Filter = ({ 
    outlets, 
    setFilteredOutlets,
    selectedMedia,
    setSelectedMedia,
    selectedTypes,
    setSelectedTypes,
    selectedOwner,
    setSelectedOwner
}) => {
    const [filterOpen, setFilterOpen] = useState(false);
    const [mediumOpen, setMediumOpen] = useState(false);
    const [typeOpen, setTypeOpen] = useState(false);
    const [ownerOpen, setOwnerOpen] = useState(true);
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    // Get unique owners from outlets
    const uniqueOwners = [...new Set(outlets.map(outlet => outlet.OWNER).filter(owner => owner))].sort();

    useEffect(() => {
        const filtered = outlets.filter(outlet => {
            const matchesMedium = selectedMedia.length === 0 ||
                selectedMedia.some(m => outlet.MEDIA_TYPE?.toLowerCase() === m.toLowerCase()) ||
                (outlet.MEDIA_TYPE === "BBC Local Radio" && selectedMedia.includes("Community Radio"));

            const matchesType = selectedTypes.length === 0 ||
                selectedTypes.includes(outlet.INDEPENDENCE ? "Independent" : "Corporate");

            const matchesOwner = !selectedOwner ||
                (outlet.OWNER && outlet.OWNER.toLowerCase().includes(selectedOwner.toLowerCase()));

            return matchesMedium && matchesType && matchesOwner;
        });

        // Handle suggestions
        if (selectedOwner && selectedOwner.length > 0) {
            const matches = uniqueOwners.filter(owner =>
                owner.toLowerCase().includes(selectedOwner.toLowerCase())
            );
            setSuggestions(matches.slice(0, 10)); // Limit to top 10
        } else {
            setSuggestions([]);
        }

        setFilteredOutlets(filtered);
    }, [selectedMedia, selectedTypes, selectedOwner, outlets, setFilteredOutlets, uniqueOwners]);

    return <div id="subtitle-bar">
        {!filterOpen && <p>Local News Outlets </p>}
        <div className={`filter ${filterOpen ? "filter-open" : "filter-closed"}`}>
            <span id="filter-toggle" onClick={() => setFilterOpen(!filterOpen)}>
                <p>Filter</p>
                {filterOpen ?
                    <img className='filter-icon' src={minus} alt="filter-closed-icon" /> :
                    <img className='filter-icon' src={plus} alt="filter-open-icon" />}
            </span>
            {filterOpen && <div id="select-container">
                <div className='select-options'>
                    <div className="select-title" onClick={() => setMediumOpen(!mediumOpen)}>
                        <p>Select Medium</p>
                        <img src={chevron} className={`chevron ${mediumOpen && "rotated"}`} alt="chevron" />
                    </div>
                    {mediumOpen ? <div className="multi-select-options">
                        <span onClick={(e) => { e.stopPropagation(); setSelectedMedia([]) }} className='filter-option'>
                            <p>All {selectedMedia.length === 0 && "✓"}</p>
                        </span>
                        {Object.keys(mediumIcons).map(medium => (
                            <span
                                key={medium}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedMedia(prev =>
                                        prev.includes(medium)
                                            ? prev.filter(m => m !== medium)
                                            : [...prev, medium]
                                    );
                                }}
                                className='filter-option'
                            >
                                {mediumIcons[medium]}
                                <p>{medium === "Print and Online" ? "Print & Online" : medium === "Local TV Station" ? "TV" : medium === "Community Radio" ? "Radio" : medium} {selectedMedia.includes(medium) && "✓"}</p>
                            </span>
                        ))}
                    </div> :
                        <span className='filter-option'>
                            <p>
                                {selectedMedia.length === 0 ? "All" :
                                    selectedMedia.length === 1 ? selectedMedia[0] :
                                        `${selectedMedia.length} Selected`} ✓
                            </p>
                        </span>
                    }
                </div>

                <div className='select-options'>
                    <div className="select-title" onClick={() => setTypeOpen(!typeOpen)}>
                        <p>Select Outlet type</p>
                        <img src={chevron} className={`chevron ${typeOpen && "rotated"}`} alt="chevron" />
                    </div>
                    {typeOpen ?
                        <div className="multi-select-options">
                            <span
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedTypes(prev =>
                                        prev.includes("Independent")
                                            ? prev.filter(t => t !== "Independent")
                                            : [...prev, "Independent"]
                                    );
                                }}
                                className='filter-option'
                            >
                                <p>{independentIcon} {selectedTypes.includes("Independent") && "✓"}</p>
                            </span>
                            <span
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedTypes(prev =>
                                        prev.includes("Corporate")
                                            ? prev.filter(t => t !== "Corporate")
                                            : [...prev, "Corporate"]
                                    );
                                }}
                                className='filter-option'
                            >
                                <p>{corporateIcon} {selectedTypes.includes("Corporate") && "✓"}</p>
                            </span>
                        </div>
                        :
                        <span className='filter-option'>
                            <p>
                                {selectedTypes.length === 0 || selectedTypes.length === 2 ?
                                    <>{independentIcon} & {corporateIcon} ✓</> :
                                    <>{selectedTypes[0] === "Independent" ? independentIcon : corporateIcon} Only ✓</>
                                }
                            </p>
                        </span>
                    }
                </div>

                <div className='select-options'>
                    <div className="select-title" onClick={() => setOwnerOpen(!ownerOpen)}>
                        <p>Search Company</p>
                        <img src={chevron} className={`chevron ${ownerOpen && "rotated"}`} alt="chevron" />
                    </div>
                    {ownerOpen && (
                        <div className="owner-search-container">
                            <input
                                type="text"
                                className="owner-search-input"
                                placeholder="Type company name..."
                                value={selectedOwner || ""}
                                onChange={(e) => {
                                    setSelectedOwner(e.target.value);
                                    setShowSuggestions(true);
                                }}
                                onFocus={() => setShowSuggestions(true)}
                                onClick={(e) => e.stopPropagation()}
                            />
                            {selectedOwner && (
                                <button
                                    className="clear-search"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedOwner(null);
                                        setShowSuggestions(false);
                                    }}
                                >
                                    ×
                                </button>
                            )}

                            {showSuggestions && suggestions.length > 0 && (
                                <div className="owner-suggestions">
                                    {suggestions.map((owner) => (
                                        <div
                                            key={owner}
                                            className="owner-suggestion-item"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setSelectedOwner(owner);
                                                setShowSuggestions(false);
                                            }}
                                        >
                                            {owner}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>

            </div>}
        </div>
    </div>
}

export default Filter;